import { gql } from '@apollo/client'
import { ServiceAgenda, ServiceItem } from '../models/sale.constants'

export type TimeWindow = {
  startDate: string
  rangeInDays: number
  timezone: string
}

export type AgendaData = {
  getAgenda: {
    retailerId: string
    dates: ServiceAgenda[]
  }
}

export interface GetAgendaVariables {
  outletId: string
  range: TimeWindow
}

export type ServiceItemsData = {
  listServiceItems: {
    serviceItems: ServiceItem[]
    // there are more pagination properties that we are not using for now
  }
}
export interface ListServiceItemsVariables {
  customerId: string
}

export const serviceAgendaBySaleIdQuery = gql`
  query ListServices($saleId: String) {
    listServices(filter: { saleId: $saleId }) {
      services {
        id
        status
        agenda {
          date
          minutesScheduled
        }
      }
    }
  }
`
export const getAgenda = gql`
  query getAgenda($outletId: String!, $range: TimeWindow) {
    getAgenda(outletId: $outletId, range: $range) {
      retailerId
      dates {
        date
        minutesScheduled
      }
    }
  }
`
export const getServiceById = gql`
  query GetService($serviceId: String!) {
    getService(serviceId: $serviceId) {
      serviceItem {
        itemId
        itemName
        serialNumber
        description
        initialCondition
      }
      notes {
        location
      }
    }
  }
`

// the data comes paginated, however, there is no pagination in the UI dropdown
export const listServiceItems = gql`
  query ListServiceItems($customerId: String) {
    listServiceItems(filter: { customerId: $customerId }) {
      serviceItems {
        itemId
        itemName
        initialCondition
        description
        serialNumber
      }
    }
  }
`
